import { Button } from "antd";
import React from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const BackButton = ({ link }) => {
  return (
    <Link to={link}>
      <Button style={{ marginBottom: 20 }}>
        <ArrowLeftOutlined />
        Назад
      </Button>
    </Link>
  );
};

export default BackButton;
